<template>
  <div class="ly-card sys-refund">
    <ly-table
      :tableHeader="tableHeader"
      :tableConfig="tableConfig"
      :paginConfig="paginConfig"
      ref="lyTable"
      class="width-full"
    >
      <!-- <template v-slot:action="row">
        <el-button @click.native="detail(row)" type="primary" size="mini">详情</el-button>
      </template>-->
    </ly-table>
  </div>
</template>
<script>
import LyTable from '@/components/LyTable';

export default {
  name: 'SysRefund',
  components: { LyTable },
  data() {
    return {
      tableHeader: [
        {
          option: {
            type: 'index'
          }
        },
        {
          value: 'name',
          name: '退费类型'
        },
        {
          value: 'info',
          name: '退费说明'
        }
      ],
      tableConfig: {
        data: [
          {
            name: '课程类',
            info:
              '学期课程类\r\n1.开课前7天以上申请，全额退费；\r\n2.开课前7天内至开课申请，退全费的95%；\r\n3.开课后至第2次上课前申请，退全费的80%；\r\n4.第2次课开课后，不再退费 '
          },
          {
            name: '活动类',
            info:
              '典型性园区主题活动及外出活动（包括园区活动、京内活动、出京活动）：\r\n1.活动前7天以上申请，扣除已发生费用，退剩余款项；\r\n2.活动前6天—1天申请，扣除已发生费用，按剩余款项的80%退费；\r\n3.活动前1天，不再办理退费。'
          },
          {
            name: '插班生',
            info: '插班生不退费。插班生是指该班第1次课开课后报名的学员。'
          }
        ]
      },
      paginConfig: {}
    };
  },
  mounted() {
    this.search();
    this.paginConfig = {
      page_no: 1,
      page_size: 10,
      total: this.tableConfig.data.length
    };
  },
  methods: {
    search() {
      this.$refs.lyTable.setData();
    }
  }
};
</script>
<style lang="less">
.sys-refund {
  .cell {
    white-space: pre-line;
  }
}
</style>
